module.exports = __webpack_public_path__ + "static/media/friluftsomraade.7d5755c8.png";